/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{InputHandler as t}from"../InputHandler.js";class e extends t{constructor(){super(!0),this.registerIncoming("context-menu",t=>t.data.native.preventDefault())}}export{e as PreventContextMenu};
